export default __webpack_public_path__ + "static/media/cam-lower.a7d5c616.svg";